module.exports = __webpack_public_path__ + "static/media/pic-tb2.ef5e7bed.png";